// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"RichError-module__wrapper___lTGtF","icon":"RichError-module__icon___BNOPq","content":"RichError-module__content___HUmdo"};